Apt.fn.extend('index', {}, {
	/**
	 * Bind pagination link actions
	 */
	paginate() {
		const scope = this;
		const pub = scope.$public;
		const conf = pub.conf;

		$.events.on('[data-num]', 'click', (e, el) => {
			if (e.metaKey) {
				return;
			}

			e.preventDefault();

			const filters = {
				page: Number(el.dataset.num)
			};

			if (conf.event) {
				pub.filter(filters, el.href);

				return;
			}

			Object.assign(conf.filters, filters);

			scope.go({
				path: conf.resource
			}, scope.prep(conf.filters));
		}, {
			delegate: conf.$target,
			namespace: pub.uid
		});
	},

	/**
	 * Get title with page number
	 *
	 * @returns {String}
	 */
	getPageTitle() {
		const num = this.$public.conf.filters.page;

		let title = LS.filters.title();

		if (num > 1) {
			title += ' - Page ' + num;
		}

		return title + ' - LandSearch';
	}
});